import axios from "axios";

export const API = axios.create({
  //baseURL: "http://localhost:1222/",
  baseURL: "https://nexaglobal.skyapi.store/",
});
